import script from "./CustomizeTableModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomizeTableModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomizeTableModal.vue?vue&type=style&index=0&id=f4d20450&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4d20450"]])

export default __exports__